import { render, staticRenderFns } from "./site-footer.vue?vue&type=template&id=84adf8e4&scoped=true&"
import script from "./site-footer.vue?vue&type=script&lang=js&"
export * from "./site-footer.vue?vue&type=script&lang=js&"
import style0 from "./site-footer.vue?vue&type=style&index=0&id=84adf8e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84adf8e4",
  null
  
)

export default component.exports